import React from 'react';
import { Row, Col, Button } from 'antd';

import ImageComponent from '@sharedComponent/image-component';
import { getMaskAccountNumber } from '@sharedComponent/bank/bank-account-card';
import Header from '@sharedComponent/header/header';
import AppLoader from '@sharedComponent/loaders/app-loader';
import AffiliateCommissionProfileFunctional from './affiliate-commission-profiles/affiliate-commission-profiles-functional';
import { devlog } from '@helpers';
import { LeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

export const ViewAffiliatePresentational = ({
	history,
	affiliateByIDLoading,
	affiliateByIDData: {
		bankingDetailsViewModels = [],
		businessName = null,
		businessUrl = null,
		coverImage = null,
		email = null,
		firstName = null,
		lastName = null,
		password = null,
		phone = null,
		profileImage = null,
		userName = null,
	},
}) => {
	let bankModel = {
		accountNickName: null,
		accountNumber: null,
		accountType: null,
		bankName: null,
		isActive: null,
		routingNumber: null,
	};
	devlog({ bankingDetailsViewModels });
	bankingDetailsViewModels &&
		bankingDetailsViewModels.forEach((res) => {
			if (res.isActive) {
				bankModel.accountNickName = res && res.accountNickName ? res.accountNickName : null;
				bankModel.accountNumber = res && res.accountNumber ? res.accountNumber : null;
				bankModel.accountType = res && res.accountType ? res.accountType : null;
				bankModel.bankName = res && res.bankName ? res.bankName : null;
				bankModel.isActive = res && res.isActive ? res.isActive : false;
				bankModel.routingNumber = res && res.routingNumber ? res.routingNumber : null;
				// bankModel.accountId = res.accountId || null;
				// bankModel.confirmRoutingNumber = res.confirmRoutingNumber || null;
				// bankModel.confirmAccountNumber = res.confirmAccountNumber || null;
			}
		});

	return (
		<Row className="affiliate_commission_profile_container">
			<Col xl={24}>
				<Header
					title={
						<>
							{<Link to="/affiliate-management">Affiliate Management</Link>}/{firstName}
						</>
					}
					hideAddAffiliate
				/>
			</Col>
			<Col style={{ width: '100%' }}>
				<>
					<Col className="affiliate_profile_area">
						{affiliateByIDLoading ? (
							<Col style={{ minHeight: 100, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
								<AppLoader width="5%" height="5%" />
							</Col>
						) : (
							<Row style={{ alignItems: 'center' }}>
								<Col xl={12} lg={12} md={24} sm={24} xs={24}>
									<Row style={{ alignItems: 'center' }}>
										<Col xl={12} lg={12} md={24} sm={24} xs={24} className="view_affiliate_img_container">
											<ImageComponent
												className="view_affiliate_img"
												src={profileImage || 'https://vanderhydelawsuitattorney.com/images/avatar.png'}
											/>
											<Col className="view_affiliate_username">{userName}</Col>
										</Col>
										{firstName ? (
											<Col xl={12} lg={12} md={24} sm={24} xs={24}>
												<Row className="view_affiliate_user_area">
													<Col xl={11} lg={11} md={11} sm={24} xs={24}>
														Name
													</Col>
													<Col xl={2} lg={2} md={2}></Col>
													<Col xl={11} lg={11} md={11} sm={24} xs={24}>
														{firstName}
													</Col>
													<Col className="view_affiliate_bottom_line" xl={24} lg={24} md={24} sm={24} xs={24}></Col>
												</Row>
												<Row className="view_affiliate_user_area">
													<Col xl={11} lg={11} md={11} sm={24} xs={24}>
														Email ID
													</Col>
													<Col xl={2} lg={2} md={2}></Col>
													<Col xl={11} lg={11} md={11} sm={24} xs={24}>
														{email}
													</Col>
													<Col className="view_affiliate_bottom_line" xl={24} lg={24} md={24} sm={24} xs={24}></Col>
												</Row>
												<Row className="view_affiliate_user_area">
													<Col xl={11} lg={11} md={11} sm={24} xs={24}>
														Phone Number
													</Col>
													<Col xl={2} lg={2} md={2}></Col>
													<Col xl={11} lg={11} md={11} sm={24} xs={24}>
														{phone}
													</Col>
													<Col className="view_affiliate_bottom_line" xl={24} lg={24} md={24} sm={24} xs={24}></Col>
												</Row>
												<Row className="view_affiliate_user_area">
													<Col xl={11} lg={11} md={11} sm={24} xs={24}>
														Business
													</Col>
													<Col xl={2} lg={2} md={2}></Col>
													<Col xl={11} lg={11} md={11} sm={24} xs={24}>
														{businessName}
													</Col>
													<Col className="view_affiliate_bottom_line" xl={24} lg={24} md={24} sm={24} xs={24}></Col>
												</Row>
												<Row className="view_affiliate_user_area">
													<Col xl={11} lg={11} md={11} sm={24} xs={24}>
														URL
													</Col>
													<Col xl={2} lg={2} md={2}></Col>
													<Col xl={11} lg={11} md={11} sm={24} xs={24}>
														{businessUrl}
													</Col>
													<Col className="view_affiliate_bottom_line" xl={24} lg={24} md={24} sm={24} xs={24}></Col>
												</Row>
											</Col>
										) : (
											<Col
												style={{
													height: '80%',
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center',
													fontSize: '18px',
													fontFamily: 'Gilroy-Semibold',
												}}>
												No Profile details found
											</Col>
										)}
									</Row>
								</Col>
								<Col xl={12} lg={12} md={24} sm={24} xs={24}>
									<Row>
										<Col xl={6} lg={6} md={24} sm={24} xs={24}></Col>
										{bankModel && bankModel.bankName && bankModel.bankName !== undefined ? (
											<Col xl={18} lg={18} md={24} sm={24} xs={24}>
												<Row className="affiliate_bank_info">
													<Col className="header" xl={24} lg={24} md={24} sm={24} xs={24}>
														Bank Details
													</Col>
													<Col className="row_card" xl={11} lg={11} md={24} sm={24} xs={24}>
														{' '}
														Bank Name
													</Col>
													<Col className="row_card" xl={2} lg={2} md={24} sm={24} xs={24}>
														{' '}
													</Col>
													<Col className="row_card textright" xl={11} lg={11} md={24} sm={24} xs={24}>
														{bankModel.bankName}
													</Col>
													<Col className="row_card " xl={24} lg={24} md={24} sm={24} xs={24}>
														{' '}
													</Col>

													<Col className="row_card" xl={11} lg={11} md={24} sm={24} xs={24}>
														{' '}
														Account Number
													</Col>
													<Col className="row_card" xl={2} lg={2} md={24} sm={24} xs={24}>
														{' '}
													</Col>
													<Col className="row_card textright" xl={11} lg={11} md={24} sm={24} xs={24}>
														{bankModel.accountNumber}
													</Col>
													<Col className="row_card" xl={24} lg={24} md={24} sm={24} xs={24}>
														{' '}
													</Col>

													<Col className="row_card" xl={11} lg={11} md={24} sm={24} xs={24}>
														{' '}
														Routing Number
													</Col>
													<Col className="row_card" xl={2} lg={2} md={24} sm={24} xs={24}>
														{' '}
													</Col>
													<Col className="row_card textright" xl={11} lg={11} md={24} sm={24} xs={24}>
														{bankModel.routingNumber}
													</Col>
													<Col className="row_card" xl={24} lg={24} md={24} sm={24} xs={24}>
														{' '}
													</Col>

													<Col className="row_card" xl={11} lg={11} md={24} sm={24} xs={24}>
														{' '}
														Account Type
													</Col>
													<Col className="row_card" xl={2} lg={2} md={24} sm={24} xs={24}>
														{' '}
													</Col>
													<Col className="row_card textright" xl={11} lg={11} md={24} sm={24} xs={24}>
														{bankModel.accountType}
													</Col>
													<Col className="row_card" xl={24} lg={24} md={24} sm={24} xs={24}>
														{' '}
													</Col>
												</Row>
											</Col>
										) : (
											<Col
												style={{
													height: '80%',
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center',
													fontSize: '18px',
													fontFamily: 'Gilroy-Semibold',
												}}>
												No Bank details found
											</Col>
										)}
									</Row>
								</Col>
							</Row>
						)}
					</Col>

					<AffiliateCommissionProfileFunctional history={history} />
				</>
			</Col>
		</Row>
	);
};
